import "./SelectedReports.css";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import ClipLoader from "react-spinners/ClipLoader";
import { isDisabled } from "@testing-library/user-event/dist/utils";
import Axios from "axios";
import fileDownload from "js-file-download";
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
import { Layout, Modal } from 'antd';
import axios from "axios";
const { Header, Content } = Layout;

const SelectedReports = () => {
    const location = useLocation();
    const { selected } = location.state ? location.state : null;
    const { selectedFrequency } = location.state ? location.state : null;
    const jwtToken = Cookies.get("jwt_token");
    const userLogin = Cookies.get("UserLogin");
    const [isloading, setloading] = useState(false);
    const [timestamp, setTimestamp] = useState("");
    // const [IsError, setIsError] = useState(false);
    // const [isModal, setModal] = useState(false);
    const [result, getdata] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [totalClients, setTotalClients] = useState()
    const [downloadedClients, setDownloadedClients] = useState(0)
    const [output, setdata] = useState([]);
    const [clientsOfVMS, setClientsOfVMS] = useState([])
    const [vmsClients, setVmsClients] = useState([])
    const [value, setValue] = useState([]);
    const [now, setNow] = useState(0);
    const [showProgressbar, setShowProgressbar] = useState(false)
    const [progressWidth, setProgressWidth] = useState(false);
    var count;
    var countIncrement = 0;
    useEffect(() => {
        callSelectedClients()
    }, []);

    const callSelectedClients = async () => {
        const res = await axios(`${process.env.REACT_APP_BASE_URL}Home/getclientslist/` + selected, {
            method: "GET",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
        })
        const tempdata = res.data
        getdata(tempdata)
    }

    function addOptions(fromId, toId) {
        var fromEl = document.getElementById(fromId),
            toEl = document.getElementById(toId);
        if (fromEl.selectedIndex >= 0) {
            var index = toEl.options.length;
            for (var i = 0; i < fromEl.options.length; i++) {
                if (fromEl.options[i].selected) {
                    toEl.options[index] = fromEl.options[i];
                    i--;
                    index++;
                }
            }
        }
    }
    const DeleteFiles = (e) => {
        Axios({
            url:
                `${process.env.REACT_APP_BASE_URL}Home/deleteFiles?userLogin=` +
                userLogin,
            method: "GET",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
        }).catch((err) => alert(err));
    };

    const downloadFiles = async (e) => {
        setShowProgressbar(false);
        try {
            const response = await Axios({
                url:
                    `${process.env.REACT_APP_BASE_URL}Home/DownloadZipFile?filename=` +
                    userLogin,
                method: "GET",
                responseType: "blob",
                headers: {
                    "content-type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },
            })
            fileDownload(response.data, "Payroll.zip");
            DeleteFiles();
            setIsModalOpen(false);
        }
        catch (error) {
            DeleteFiles();
            setIsModalOpen(false);
            //   console.log(error)
        }
    };

    const progressCloseButton = () => {
        setShowProgressbar(false)
    }

    const handleClick = async () => {
        //alert(isloading)
        setShowProgressbar(false)
        setProgressWidth(false)
        setDownloadedClients(0)
        countIncrement = 0
        setNow(parseInt(countIncrement))
        try {
            let AR = [];
            var secondBox = document.getElementById("select2");
            let length = secondBox.options.length;
            setTotalClients(length)
            count = 100 / length;
            let tempAR = [];
            for (let i = 0; i < secondBox.options.length; i++) {
                AR.push(secondBox.options[i].value);
                tempAR = [];
                tempAR.push(AR[i]);
                setloading(true)
                setShowProgressbar(true)
                setProgressWidth(true)
                try {
                    const res = await Axios.post(
                        `${process.env.REACT_APP_BASE_URL}Home/DownloadForSelectedClients?VMS=` +
                        selected +
                        `&frequency=` +
                        selectedFrequency +
                        `&userLogin=` +
                        userLogin,
                        JSON.stringify(tempAR),
                        {
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${jwtToken}`,
                            },
                        }
                    )
                    callNowPercentage(count, i)
                }
                catch (err) {
                    setloading(false);
                    // setIsModalOpen(true);
                    console.log("**Error Message**  :" + err);
                }
            }
            setloading(false)
            setProgressWidth(false)
            setShowProgressbar(false)
            info();
        }
        catch (error) {
            console.log(error)
        }
    };
    const callNowPercentage = async (count, int) => {
        setProgressWidth(true)
        countIncrement = countIncrement + count;
        setNow(parseInt(countIncrement))
        setDownloadedClients(int + 1)
    }
    const filterOptions = (selectId) => {
        const searchQuery = document.getElementById("search").value.toLowerCase();
        const options = document.getElementById(selectId).options;
        for (let i = 0; i < options.length; i++) {
            const option = options[i];
            if (option.text.toLowerCase().indexOf(searchQuery) === -1) {
                option.style.display = "none";
            } else {
                option.style.display = "block";
            }
        }
    };
    const info = () => {
        Modal.info({
            icon: null,
            title: 'Finished processing your request, Click OK to download the files',
            onOk() {
                downloadFiles()
                setIsModalOpen(false);
                setloading(false)
            },
        });
    };

    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        DeleteFiles();
        setIsModalOpen(false);
    };

    return (
        <>
            <Layout style={{ display: "flex", flexDirection: "row", alignContent: "center", overflow:'hidden' }} className={isloading ? "blur" : ""}>
                <SideNavBar />
                <Layout style={{ backgroundColor: "white" }}>
                    <Header className="selected-header">
                        <Navbar />
                    </Header>
                    <div style={{ padding: "0px", marginTop: "100px", display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "20px",
                                width: 500,
                                // marginLeft: 200,
                            }}
                        >

                            <input
                                className="form-control"
                                type="text"
                                id="search"
                                placeholder="Search"
                                onKeyUp={() => filterOptions("select1")}
                            />

                        </div>
                        <div className="row1">
                            <div className="col-2">
                                <select
                                    multiple="multiple"
                                    size="8"
                                    id="select1"
                                    name="select1"
                                    className="listbox"
                                    style={{ marginLeft: 50, marginRight: 230 }}
                                >
                                    {result.sort((a, b) => {
                                        const aWord = a.match(/[a-z]+/i)[0];
                                        const bWord = b.match(/[a-z]+/i)[0];
                                        if (aWord < bWord) {
                                            return -1;
                                        } else if (aWord > bWord) {
                                            return 1;
                                        } else {
                                            return 0;
                                        }
                                    }).map((items, index) => (
                                        <option key={index}>{items}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="buttons">
                                <input
                                    type="button"
                                    className="move_button"
                                    id="add"
                                    value="&#8702;"
                                    onClick={() => addOptions("select1", "select2")}
                                />
                                <br />
                                <input
                                    type="button"
                                    className="move_button"
                                    id="remove"
                                    value="&#8701;"
                                    onClick={() => addOptions("select2", "select1")}
                                />
                            </div>
                            <div className="col-2">
                                <select
                                    className="listbox"
                                    id="select2"
                                    size="8"
                                    name="select2"
                                    multiple="multiple"
                                    style={{ marginLeft: 200, }}
                                ></select>
                            </div>
                        </div>
                        <div className={isloading ? "btndisabled" : "download-btn"}>
                            <input
                                className="submit-btn"
                                onClick={handleClick}
                                type="submit"
                                value="Download"
                            />
                        </div>
                    </div>
                </Layout>
                {/* </div> */}
            </Layout>
            {
                showProgressbar &&
                <div className="popup">
                    <div className="popup-inner">
                        <div className="name-progress">
                            <div className="download-head">Downloading...</div>
                            <div className="progressbar">
                                <div className="progress-div">
                                    {progressWidth &&
                                        <div className="filled-progressbar" style={{ width: now + "%" }}>
                                            <span style={{ fontSize: 12 }}>{now}%</span>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="Vms-status">{downloadedClients} out of {totalClients} in {selected}</div>
                            <button className="close-btn" onClick={progressCloseButton}>Ok</button>
                        </div>
                    </div>
                </div>
            }
        </>
    );
};
export default SelectedReports;
